import 'moment';
import moment from 'moment-timezone';

export class TenantStats {
  dateLastCheckedIn: UtcTypeString | null = null
  dateLastLoggedIn: UtcTypeString | null = null
  hostCount: number = 0
  locationCount: number = 0
  visitCount: number = 0
}
export default class TenantClass {
  activeTo: null | string | Date = null
  companyName: string = ''
  email: string = ''
  entity?: BaseEntityProps
  firstName: string = ''
  id: number | undefined = undefined
  isCustomer?: boolean
  lastName: string = ''
  maxLocations: number = 5
  mobile: string = ''
  status: string = ''
  stats: TenantStats = new TenantStats()
  
  constructor (o?: TenantClass) {
    if (o) {
      this.activeTo = o.activeTo ? moment.utc(o.activeTo).toDate() : null;
      this.companyName = o.companyName;
      this.email = o.email;
      this.entity = o.entity;
      this.firstName = o.firstName;
      this.id = o.id;
      this.isCustomer = o.isCustomer;
      this.lastName = o.lastName;
      this.maxLocations = o.maxLocations || 5;
      this.mobile = o.mobile;
      this.status = o.status;
      this.stats = o.stats;
    }
  }
}